import type { ElementType, ReactNode } from "react";

export enum ContextMenuVariant {
  PRIMARY = "primary",
  DESTRUCTIVE = "destructive",
}

export interface ContextMenuItems<TData> {
  id: string;
  label?: string;
  icon?: ElementType;
  group?: string;
  className?: string;
  getDisabled?: (data: TData) => boolean;
  hidden?: boolean;
  showIf?: (data: TData) => boolean;
  getContent?: (data: TData) => ReactNode;
  preventCloseOnSelect?: boolean | ((data: TData) => boolean);
  tooltipContent?: string | ((data: TData) => string | undefined);
  onClick?: (data: TData) => void;
  isDivider?: boolean;
  variant?: ContextMenuVariant;
}

export interface ContextMenuProps<TData> {
  contextMenuItems?: ContextMenuItems<TData>[];
  data: TData;
  children: ReactNode;
  isDisabled?: boolean;
  shouldOpenContextMenuByLeftClick?: boolean;
  className?: string;
  modal?: boolean;
  usePortal?: boolean;
  preventAutoFocusOnClose?: boolean;
}
